const EXECUTION_PLATFORM_LABELS = {
  'Camunda Cloud': {
    '1.0': 'Camunda Platform 8 (Zeebe 1.0)',
    '1.1': 'Camunda Platform 8 (Zeebe 1.1)',
    '1.2': 'Camunda Platform 8 (Zeebe 1.2)',
    '1.3': 'Camunda Platform 8 (Zeebe 1.3)',
    '8.0': 'Camunda Platform 8.0',
    '8.1': 'Camunda Platform 8.1',
    '8.2': 'Camunda Platform 8.2',
    '8.3': 'Camunda Platform 8.3',
    '8.4': 'Camunda Platform 8.4',
    '8.5': 'Camunda Platform 8.5',
    '8.6': 'Camunda Platform 8.6',
    '8.7': 'Camunda Platform 8.7',
    '8.8': 'Camunda Platform 8.8'
  }
};

export function toSemverMinor(version) {
  return version.split('.').slice(0, 2).join('.');
}

export function getExecutionPlatformLabel(schema) {

  const {
    executionPlatform,
    executionPlatformVersion
  } = schema;

  const executionPlatformVersionMinor = toSemverMinor(executionPlatformVersion);


  if (EXECUTION_PLATFORM_LABELS[executionPlatform] && EXECUTION_PLATFORM_LABELS[executionPlatform][executionPlatformVersionMinor]) {
    return EXECUTION_PLATFORM_LABELS[executionPlatform][executionPlatformVersionMinor];
  }

  return `${executionPlatform} ${executionPlatformVersionMinor}`;
}
